import { DateTime as DateTimeLuxon } from 'luxon';
import { type } from '@mews-framework/utils';

interface DateTime {
    value: string;
    timezone: string;
    millis: number;
}

function DateTime(luxon: DateTimeLuxon): DateTime {
    return type.create(DateTime, {
        value: luxon.toISO({ includeOffset: false }),
        timezone: luxon.zoneName,
        millis: luxon.toMillis(),
    });
}

export default DateTime;
